import React from 'react'
// import quote_bg from '../assets/quote_bg.jpg'

import service_bg from '../assets/service_bg.jpg'
import data_analytics from '../assets/data_analytics.webp'
import business_intelligence from '../assets/business_intelligence.jpg'
import ai_and_ml from '../assets/ai_and_ml.jpg'
import kpi_dashboarding from '../assets/kpi_dashboarding.png'
import proj_management from '../assets/proj_management.webp'
import website_development from '../assets/website_development.png'

import { Link } from 'react-router-dom';

const Services = () => {
    const serviceBoxes = [
    {
        img: data_analytics,
        headline: 'Data Analytics and Consulting',
        link: '/services/data-analytics'
    },
    {
        img: business_intelligence,
        headline: 'Business Intelligence',
        link: '/services/business-intelligence'
    },
    {
        img: ai_and_ml,
        headline: 'AI & ML',
        link: '/services/ai-and-ml'
    },
    {
        img: kpi_dashboarding,
        headline: 'KPI Dashboarding',
        link: '/services/kpi-dashboarding'
    },
    {
        img: proj_management,
        headline: 'Project Management',
        link: '/services/project-management'
    },
    {
        img: website_development,
        headline: 'Website Development Services',
        link: '/services/website-development'
    },
    ];
  return (
    <div>
        <div className='mt-20 relative'>
          <div className='relative mt-[6rem]'>
            {/* Background Image with Reduced Opacity */}
            <img
              className='w-full h-[40rem] blur-sm object-cover'
              src={service_bg}
              alt='quote background'
              style={{
                clipPath: 'polygon(0 0, 100% 0, 100% 85%, 0% 100%)',
              }}
            //   style={{ opacity: 0.75 }}
            />

            {/* Text Overlay */}
            <div className='absolute inset-0 flex items-center justify-center'>
              <p className='text-white text-6xl bold'>
                Data and Analytics at Jyotinay Analytics
              </p>
            </div>
          </div>
        </div>
        <div className="px-4 py-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {serviceBoxes.map((service, index) => (
                <Link to={service.link} key={index}>
                <div className="relative h-60 w-full rounded-lg overflow-hidden shadow-lg cursor-pointer transform transition-transform duration-300 hover:scale-105 group">
                    <img
                    src={service.img}
                    alt={service.headline}
                    className="h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                    <h2 className="text-white text-xl font-semibold transition-opacity duration-300">
                        {service.headline}
                    </h2>
                    </div>
                </div>
                </Link>
            ))}
            </div>

    </div>
  )
}

export default Services